module.exports = __webpack_public_path__ + "59384d2956d572c495d21628d40795a8.png";